import React, { useCallback, useState, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Grid, Button, Tooltip } from '@material-ui/core';
import { Query } from 'material-table';
import { HtmlView, MTable, BackButton } from '../../../../../Components';
import { IGridQueryRequest, OrderDirection } from '../../../../../Api/AptorApi';
import { useAptorApi } from '../../../../../Api';
import moment from 'moment';
import { ArrowUpward } from '@material-ui/icons'
import { useStyles } from "../../../LawPortal.styles";


type RelatedLawData = {
  id: number;
  number: string;
  name: string;
  area: string;
  description: string;
  changeNumber?: string;
  changeEffectiveFrom?: Date;
  hasAccessToLaw: boolean;
};

export const RelatedLaws = () => {
  const match = useRouteMatch<{ id: string }>();
  const id = parseInt(match.params.id);
  const { api } = useAptorApi();
  const { formatMessage } = useIntl();
  const history = useHistory();
  const classes = useStyles()

  const handleDataFetch = useCallback(
    async (query: Query<RelatedLawData>) => {
      return await api.searchLawPortalRelatedLaws<RelatedLawData>(id, {
        orderDirection: query.orderDirection === 'desc' ? OrderDirection.Descending : OrderDirection.Ascending,
        orderBy: query.orderBy !== undefined ? query.orderBy.field : 'number',
        page: query.page,
        pageSize: query.pageSize,
        search: query.search,
      } as IGridQueryRequest);
    },
    [id, api],
  );

  const renderDate = (date?: Date) => {
    return date ? moment(date).format('ll') : undefined;
  };
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <BackButton disableMargin link="/law-portal/our-laws/" />
        {/* <BackButton disableMargin link="" onclick={()=>history.goBack()} /> */}
      </Grid>
      <Grid item md={9} xs={12}>
        <MTable
          columns={[
            { title: formatMessage({ id: 'law-portal.our-laws.table.number' }), field: 'number' },
            { title: formatMessage({ id: 'law-portal.our-laws.table.law' }), field: 'name' },
            {
              title: formatMessage({ id: 'law-portal.our-laws.table.description' }),
              field: 'description',
              render: (row) => <HtmlView variant="body2" value={row.description} />,
              sorting: false,
            },
            { title: formatMessage({ id: 'law-portal.our-laws.table.area' }), field: 'area' },
            { title: formatMessage({ id: 'law-portal.our-laws.table.changeNumber' }), field: 'changeNumber' },
            {
              title: formatMessage({ id: 'law-portal.our-laws.table.changeEffectiveFrom' }),
              field: 'changeEffectiveFrom',
              render: (row) => renderDate(row.changeEffectiveFrom),
            },
          ]}
          data={handleDataFetch}
          onRowClick={(_, row) => row && row.hasAccessToLaw && history.push(`/law-portal/our-laws/${row.id}`)}
          options={{
            toolbar: false,
            paging: false,
            rowStyle: (row) => (row.hasAccessToLaw === false ? { pointerEvents: 'none' } : {}),
          }}
          components={{}}
        />
      </Grid>
      {showScrollTop && (
        <Tooltip title={formatMessage({ id: "bottom.to.top.btn.tooltip.text", defaultMessage: "Back to top" })}>
          <Button
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className={classes.topButton}
          >
            <ArrowUpward style={{ fontSize: 20 }} />
          </Button>
        </Tooltip>
      )}

    </>
  );
};
